var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicationsRejected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "file_14_",
    "data-name": "file (14)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.287,
    height: 54.5,
    viewBox: "0 0 54.287 54.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46611",
    "data-name": "Path 46611",
    d: "M150.272,13.838a1.6,1.6,0,0,1-1.6-1.6V0H125.79A4.8,4.8,0,0,0,121,4.79V22.64c.526-.048,1.058-.073,1.6-.073a17.535,17.535,0,0,1,13.538,6.387h17.331a1.6,1.6,0,0,1,0,3.193H138.239a17.43,17.43,0,0,1,1.848,6.387h13.379a1.6,1.6,0,1,1,0,3.193H140.087a17.57,17.57,0,0,1-7.4,12.773h25.04a4.8,4.8,0,0,0,4.79-4.79V13.838Zm3.193,8.729H130.048a1.6,1.6,0,1,1,0-3.193h23.418a1.6,1.6,0,1,1,0,3.193Z",
    transform: "translate(-108.227)",
    fill: "#64b5f6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46612",
    "data-name": "Path 46612",
    d: "M411,8.783v9.71h9.709Z",
    transform: "translate(-367.357 -7.848)",
    fill: "#64b5f6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46613",
    "data-name": "Path 46613",
    d: "M15.37,242a14.37,14.37,0,1,0,14.37,14.37A14.386,14.386,0,0,0,15.37,242Zm5.919,18.031a1.6,1.6,0,1,1-2.258,2.258l-3.661-3.661-3.661,3.661a1.6,1.6,0,0,1-2.258-2.258l3.661-3.661-3.661-3.661a1.6,1.6,0,1,1,2.258-2.258l3.661,3.661,3.661-3.661a1.6,1.6,0,0,1,2.258,2.258l-3.661,3.661Z",
    transform: "translate(-1 -216.24)",
    fill: "#ff7171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsRejected);
export default __webpack_public_path__ + "static/media/applications-rejected.21cc9fb4a1e7985a024ddecc1d87ff20.svg";
export { ForwardRef as ReactComponent };